export default __webpack_public_path__ + "resources/icons/d121-aaf1.png";